import { useQuery } from "@tanstack/react-query";
import { graphqlClient } from "@/lib/graphql-client";
import { PublicCompanyQuery } from "@/queries";

export function usePublicCompany(companyId: number) {
  return useQuery({
    queryKey: ["publicCompany", companyId],
    queryFn: () =>
      graphqlClient
        .request(PublicCompanyQuery, {
          companyId,
        })
        .then((res) => res.getPublicCompanyInfo),
    enabled: !!companyId && !Number.isNaN(companyId),
  });
}
